export default "__VITE_ASSET__CCbtSaoQ__"